import PropTypes from 'prop-types';
import React from 'react';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';

import './SponsorDisplay.scss';

const FGBLogoSrc =
    '//d207ibygpg2z1x.cloudfront.net/image/upload/c_scale,ar_1:1,dpr_auto,fl_lossy,f_auto,q_auto,w_80/v1/events/fikvogqebruab305d0h3';

export default class SponsorDisplay extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        sponsors: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                image: PropTypes.shape({
                    src: PropTypes.string.isRequired,
                    alt: PropTypes.string,
                }),
                companyId: PropTypes.number,
                description: PropTypes.string,
            })
        ).isRequired,
        injectedTransforms: PropTypes.shape({
            companyIcon: PropTypes.string,
        }),
    };

    static defaultProps = {
        injectedTransforms: {
            companyIcon:
                'ar_1:1,c_lpad/c_scale,f_auto,q_auto,dpr_auto,fl_lossy,w_80',
        },
    };

    render() {
        const { sponsors, injectedTransforms } = this.props;

        if (!sponsors || sponsors.length === 0) return null;

        let SponsorLogoDisplay = null;

        // if we have more than 3 sponsors, only show default FGB logo
        if (sponsors.length > 3) {
            SponsorLogoDisplay = (
                <div
                    className={`singleEventImageDisplay-companyIcon-container`}
                >
                    <img
                        className="singleEventImageDisplay-companyIcon"
                        alt="fairygodboss-logo"
                        src={FGBLogoSrc}
                    />
                </div>
            );
        } else {
            SponsorLogoDisplay = sponsors.map((sponsor, idx) => {
                const hasSponsorImage = sponsor.image && sponsor.image.src;

                if (!hasSponsorImage) return null;

                const marginStying = idx === 0 ? '' : 'margin-left-styling';

                return (
                    <div
                        key={`${sponsor.name}-${idx}`}
                        className={`singleEventImageDisplay-companyIcon-container ${marginStying}`}
                    >
                        <img
                            alt={`${sponsor.image.alt}`}
                            className={`singleEventImageDisplay-companyIcon`}
                            src={buildImagePath(
                                sponsor.image.src,
                                'companyIcon',
                                injectedTransforms
                            )}
                        />
                    </div>
                );
            });
        }

        return (
            <div className="component-Events-SponsorDisplay">
                {SponsorLogoDisplay}
            </div>
        );
    }
}
